var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "grid-view" },
    [
      _c("div", { staticClass: "main-content" }, [
        _c(
          "div",
          { staticClass: "section" },
          [
            _c(
              "el-form",
              {
                staticStyle: { height: "100%" },
                attrs: {
                  "label-width": "50px",
                  "label-position": "right",
                  inline: ""
                }
              },
              [
                _c(
                  "el-form-item",
                  { attrs: { label: _vm.$t("Menu.Search") } },
                  [
                    _c("el-input", {
                      staticStyle: { width: "200px" },
                      attrs: { placeholder: _vm.$t("Menu.PleaseEnterChinese") },
                      on: { change: _vm.searchHandler },
                      model: {
                        value: _vm.txtSearch,
                        callback: function($$v) {
                          _vm.txtSearch = $$v
                        },
                        expression: "txtSearch"
                      }
                    })
                  ],
                  1
                ),
                _c(
                  "el-form-item",
                  [
                    _c(
                      "el-button",
                      {
                        staticStyle: { "margin-left": "5px" },
                        attrs: { type: "primary" },
                        on: { click: _vm.addMenuClickEvent }
                      },
                      [_vm._v(_vm._s(_vm.$t("Menu.AddMenu")))]
                    ),
                    _c(
                      "el-button",
                      {
                        staticStyle: { "margin-left": "5px" },
                        attrs: { type: "primary" },
                        on: { click: _vm.editMenuClickEvent }
                      },
                      [_vm._v(_vm._s(_vm.$t("Menu.UpdateMenu")))]
                    ),
                    _c(
                      "el-button",
                      {
                        staticStyle: { "margin-left": "5px" },
                        attrs: { type: "primary" },
                        on: { click: _vm.addTenantMenuClickEvent }
                      },
                      [_vm._v(_vm._s(_vm.$t("Menu.AddCustomerMenu")))]
                    ),
                    _c(
                      "el-button",
                      {
                        staticStyle: { "margin-left": "5px" },
                        attrs: { type: "primary" },
                        on: { click: _vm.btnRefreshClickEvent }
                      },
                      [_vm._v(_vm._s(_vm.$t("Menu.Refresh")))]
                    )
                  ],
                  1
                )
              ],
              1
            )
          ],
          1
        ),
        _c(
          "div",
          { staticClass: "section grid-wrapper" },
          [
            _c("cargo-ag-grid", {
              attrs: {
                "grid-options": _vm.gridOptions,
                "column-defs": _vm.columnDefs,
                "row-data": _vm.rowData
              },
              on: {
                gridReady: function(params) {
                  _vm.gridApi = params.api
                }
              }
            })
          ],
          1
        )
      ]),
      _c("sys-menu-window", {
        attrs: {
          visible: _vm.sysMenuWindow.visible,
          title: _vm.sysMenuWindow.title,
          "sys-menu": _vm.sysMenuWindow.sysMenu
        },
        on: {
          saveCallBack: _vm.sysMenuWindow.saveCallBack,
          close: function($event) {
            _vm.sysMenuWindow.visible = false
          }
        }
      }),
      _c("sys-menu-by-add-tenant-window", {
        attrs: {
          visible: _vm.tenantWindow.visible,
          menus: _vm.tenantWindow.menus
        },
        on: {
          close: function($event) {
            _vm.tenantWindow.visible = false
          }
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }